import { emailLogClient } from '@/helpers/api/apiClients'
import type { IEmailLogRepository } from './contracts/IEmailLogRepository'

/**
 * Email log service - abstraction over email log API client.
 * Use this instead of importing emailLogClient directly for better testability.
 */
export const emailLogService: IEmailLogRepository = {
	getEmailLogList: (request) => emailLogClient.getEmailLogList(request),
	getEmailLogById: (id) => emailLogClient.getEmailLogById(id),
	getInboxEmails: () => emailLogClient.getInboxEmails(),
	sendInboxEmail: (request) => emailLogClient.sendInboxEmail(request),
	replyInboxEmail: (id, request) => emailLogClient.replyInboxEmail(id, request),
	getInboxEmailList: (request) => emailLogClient.getInboxEmailList(request),
	getInboxEmailById: (id) => emailLogClient.getInboxEmailById(id),
	toggleInboxEmailStar: (id) => emailLogClient.toggleInboxEmailStar(id),
	downloadInboxAttachment: (id) => emailLogClient.downloadInboxAttachment(id),
}
